// assets/cursos.js
// Progreso en localStorage. Soporta múltiples cursos en la misma página,
// mostrando el que indique ?curso= en la URL (o el primero).
(function () {
  var bloques = Array.from(document.querySelectorAll('[data-curso-bloque]'));
  if (bloques.length === 0) return;

  // --- 1. Determinar qué curso mostrar según la URL ---
  var params = new URLSearchParams(window.location.search);
  var cursoParam = params.get('curso');
  var bloqueActivo = bloques.find(function (b) {
    return b.dataset.cursoBloque === cursoParam;
  }) || bloques[0];

  bloques.forEach(function (b) { b.hidden = (b !== bloqueActivo); });

  // Marcar el link activo del sidebar
  document.querySelectorAll('[data-curso-link]').forEach(function (link) {
    link.classList.toggle('active', link.dataset.cursoLink === bloqueActivo.dataset.cursoBloque);
  });

  // --- 2. Inicializar cada bloque de curso de forma independiente ---
  bloques.forEach(function (bloque) {
    var cursoId = bloque.dataset.cursoBloque;
    var storageKey = 'cursos_progreso_' + cursoId;

    var navItems = Array.from(bloque.querySelectorAll('.leccion-item'));
    var panels = Array.from(bloque.querySelectorAll('.leccion-panel'));
    var progressFill = bloque.querySelector('[data-progress-fill]');
    var progressLabel = bloque.querySelector('[data-progress-label]');
    var total = panels.length;

    var completadas;
    try {
      var guardado = localStorage.getItem(storageKey);
      completadas = new Set(guardado ? JSON.parse(guardado) : []);
    } catch (e) {
      completadas = new Set();
    }

    function save() {
      try {
        localStorage.setItem(storageKey, JSON.stringify(Array.from(completadas)));
      } catch (e) {}
    }

    function updateBar() {
      var pct = total > 0 ? Math.round((completadas.size / total) * 100) : 0;
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressLabel) progressLabel.textContent = pct + '% completado';
    }

    function paintDone() {
      navItems.forEach(function (item) {
        var h = item.dataset.leccionHandle;
        var done = completadas.has(h);
        item.classList.toggle('done', done);
        var num = item.querySelector('.leccion-num');
        if (num) {
          if (!num.dataset.original) num.dataset.original = num.textContent;
          num.textContent = done ? '✓' : num.dataset.original;
        }
      });
    }

    function show(handle) {
      navItems.forEach(function (i) {
        i.classList.toggle('active', i.dataset.leccionHandle === handle);
      });
      panels.forEach(function (p) {
        p.classList.toggle('active', p.dataset.leccionPanel === handle);
      });
    }

    function markDone(handle) {
      if (!completadas.has(handle)) {
        completadas.add(handle);
        paintDone();
        updateBar();
        save();
      }
    }

    function panelIndex(handle) {
      return panels.findIndex(function (p) { return p.dataset.leccionPanel === handle; });
    }

    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        show(item.dataset.leccionHandle);
      });
    });

    panels.forEach(function (panel) {
      var handle = panel.dataset.leccionPanel;
      var nextBtn = panel.querySelector('.btn-leccion-next');
      var prevBtn = panel.querySelector('.btn-leccion-prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          markDone(handle);
          var idx = panelIndex(handle);
          var next = panels[idx + 1];
          if (next) {
            show(next.dataset.leccionPanel);
          } else {
            nextBtn.textContent = '🎉 ¡Curso completado!';
            nextBtn.disabled = true;
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var idx = panelIndex(handle);
          var prev = panels[idx - 1];
          if (prev) show(prev.dataset.leccionPanel);
        });
      }
    });

    // Quiz
    bloque.querySelectorAll('.leccion-quiz').forEach(function (quiz) {
      var correcta = quiz.dataset.correcta;
      var feedback = quiz.querySelector('.quiz-feedback');
      quiz.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var ok = radio.value === correcta;
          feedback.style.display = 'block';
          feedback.textContent = ok ? '¡Correcto!' : 'No es la respuesta correcta, intenta de nuevo.';
          feedback.className = 'quiz-feedback ' + (ok ? 'correcto' : 'incorrecto');
        });
      });
    });

    // Estado inicial
    paintDone();
    updateBar();

    // Abrir la primera lección pendiente si hay progreso previo
    var pendiente = navItems.find(function (i) { return !completadas.has(i.dataset.leccionHandle); });
    if (pendiente && completadas.size > 0) {
      show(pendiente.dataset.leccionHandle);
    }
  });
})();
